export default {
  'permissions.admin': 'Администратор',
  'permissions.developer': 'Барноманавис',
  'permissions.methodologist': 'Методолог',
  'permissions.user': 'Корбар',
  'permissions.current': 'Иҷозатҳои вазифа',
  'permissions.none': 'Бэкенд ҳанӯз иҷозатҳоро намефиристад',
  'permissions.sections': 'Бахшҳои дастрас',
  'permissions.sections.all': 'Ҳамаи бахшҳо',
  'permissions.preview.label': 'Интерфейсро бо иҷозатҳои дигар бинед',
  'permissions.preview.actual': 'Мисли профил',
  'permissions.preview.hint':
    'Танҳо ҷобаҷогузории интерфейс дар ин дастгоҳ иваз мешавад. Токен ва санҷишҳо дар сервер бетағйир мемонанд.',
  'permissions.preview.active':
    'Интерфейс аз рӯи иҷозатҳои интихобшуда сохта шудааст. Аз бэкенд омад: {actual}.',
  'permissions.welcome.frameTitle': 'Дастрасӣ ва интерфейс',
};
